import { SagaIterator } from "redux-saga";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  completeChecklistShift,
  completeChecklistShiftFailure,
  completeChecklistShiftSuccess,
  fetchChecklistTaskById,
  fetchChecklistTaskByIdFailure,
  fetchChecklistShift,
  fetchChecklistShiftFailure,
  fetchChecklistShiftSuccess,
  fetchChecklistTasks,
  fetchChecklistTasksFailure,
  fetchChecklistTasksSuccess,
  returnChecklistShiftToWork,
  returnChecklistShiftToWorkFailure,
  returnChecklistShiftToWorkSuccess,
  setChecklistSelectedTaskId,
  upsertChecklistTask,
} from "./actions";
import {
  completeChecklistShiftRequest,
  fetchChecklistShiftDataset,
  fetchChecklistTaskByConnection,
  fetchChecklistTasksDataset,
  returnChecklistShiftToWorkRequest,
} from "./api";

function* fetchChecklistTasksWorker({ payload }: ReturnType<typeof fetchChecklistTasks>): SagaIterator {
  try {
    const { tasks, shifts } = yield call(fetchChecklistTasksDataset, payload);
    yield put(fetchChecklistTasksSuccess({ tasks, filters: payload }));
    yield put(
      fetchChecklistShiftSuccess({
        shifts,
        filters: {
          email: payload.email,
          date: payload.periodDate?.startDate,
        },
      })
    );
  } catch (error) {
    yield put(fetchChecklistTasksFailure((error as Error)?.message ?? "Не удалось загрузить задачи чек-листа"));
    yield put(fetchChecklistShiftFailure((error as Error)?.message ?? "Не удалось загрузить смену"));
  }
}

function* fetchChecklistTaskByIdWorker({ payload }: ReturnType<typeof fetchChecklistTaskById>): SagaIterator {
  try {
    const task = yield call(fetchChecklistTaskByConnection, {
      connectionId: payload.connectionId,
      periodDate: payload.periodDate,
      email: payload.targetEmail,
      currentUserEmail: payload.currentUserEmail,
    });

    if (task) {
      yield put(upsertChecklistTask(task));
      yield put(setChecklistSelectedTaskId(Number(task.ConnectionID)));
    } else {
      yield put(fetchChecklistTaskByIdFailure("Задача не найдена"));
    }
  } catch (error) {
    yield put(fetchChecklistTaskByIdFailure((error as Error)?.message ?? "Не удалось загрузить задачу чек-листа"));
  }
}

function* fetchChecklistShiftWorker({ payload }: ReturnType<typeof fetchChecklistShift>): SagaIterator {
  try {
    const shifts = yield call(fetchChecklistShiftDataset, payload);
    yield put(fetchChecklistShiftSuccess({ shifts, filters: payload }));
  } catch (error) {
    yield put(fetchChecklistShiftFailure((error as Error)?.message ?? "Не удалось загрузить смену"));
  }
}

function* completeChecklistShiftWorker({ payload }: ReturnType<typeof completeChecklistShift>): SagaIterator {
  try {
    const ID = yield call(completeChecklistShiftRequest, payload);

    if (ID) {
      yield put(completeChecklistShiftSuccess({ ID: Number(ID), payload }));
      const filters = yield select((state) => state.checklistTasks.filters);
      if (filters) {
        yield put(fetchChecklistTasks(filters));
      }
    } else {
      yield put(completeChecklistShiftFailure("Не удалось завершить смену"));
    }
  } catch (error) {
    yield put(completeChecklistShiftFailure((error as Error)?.message ?? "Не удалось завершить смену"));
  }
}

function* returnChecklistShiftToWorkWorker({ payload }: ReturnType<typeof returnChecklistShiftToWork>): SagaIterator {
  try {
    const result = yield call(returnChecklistShiftToWorkRequest, payload);

    if (result) {
      yield put(returnChecklistShiftToWorkSuccess(payload));
      const filters = yield select((state) => state.checklistTasks.filters);
      if (filters) {
        yield put(fetchChecklistTasks(filters));
      }
    } else {
      yield put(returnChecklistShiftToWorkFailure("Не удалось вернуть смену в работу"));
    }
  } catch (error) {
    yield put(returnChecklistShiftToWorkFailure((error as Error)?.message ?? "Не удалось вернуть смену в работу"));
  }
}

export function* checklistTasksWatcher(): SagaIterator {
  yield takeLatest(fetchChecklistTasks.toString(), fetchChecklistTasksWorker);
  yield takeLatest(fetchChecklistTaskById.toString(), fetchChecklistTaskByIdWorker);
  yield takeLatest(fetchChecklistShift.toString(), fetchChecklistShiftWorker);
  yield takeLatest(completeChecklistShift.toString(), completeChecklistShiftWorker);
  yield takeLatest(returnChecklistShiftToWork.toString(), returnChecklistShiftToWorkWorker);
}

